
import {defineComponent, reactive, ComputedRef, computed, toRefs} from "vue";
import {useRouter, useRoute} from "vue-router";
import {useStore} from "@/store";
import  reportMsgUt from "@/util/reportMsg";

interface State {
    defectPhotoList: any;
    reportMsg: object;
    templateCode: string;
}
export default defineComponent({
    name: 'checkPositionCont',
    props: {
        checkPositionContRenderData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        checkPositionContRenderKey: {
            type: String,
            default: ''
        }
    },
    setup() {
         let state: State = reactive({
            defectPhotoList: [],
            reportMsg: {},
            templateCode: ''
         })
        state.reportMsg = reportMsgUt;
         const store = useStore()
         const router = useRouter();
        const {query} = useRoute();
        const {templateCode} = query;
        state.templateCode = String(templateCode) || ''
        let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
        const {defectPhotoList} = dataInfo.value as any
        state.defectPhotoList = defectPhotoList;
         return {
             state,
             router
         }
    },
    methods: {
        goToImgView(photo) {
            if (photo === 'all') {
                this.router.push({
                    path:'/tocV3PhotoList',
                    query: {
                        photoIndex:0,
                        group: 'defect',
                        isAll: 'total',
                        templateCode: this.state.templateCode
                    }
                })
            } else {
                let currentIndex=0;
                for (let i =0;i<this.state.defectPhotoList.length;i++){
                    if (this.state.defectPhotoList[i].photoIdStr === photo.photoIdStr) {
                        currentIndex = i;
                    }
                }
                this.router.push({
                    path:'/tocV3PhotoList',
                    query: {
                        photoIndex: currentIndex,
                        group: 'defect' ,
                        templateCode: this.state.templateCode
                    }
                })
            }
            
        }
    }
})
